// removed by extract-text-webpack-plugin


//////////////////
// WEBPACK FOOTER
// ./src/common/AlertHeadline/AlertHeadline.css
// module id = 380
// module chunks = 0